import { ApprovalRequestMessage, ApprovedApprovalRequestMessage } from '../../../types/ApprovalRequestMessage';
import { OfferModel } from '../model/OfferModel';

import { ApprovalRequestBasicContent } from './ApprovalRequestBasicContent';
import { ApprovedStatusBar } from './ApprovedStatusBar';

interface ApprovedStateProps {
    offer: OfferModel;
    approvalRequests: ApprovalRequestMessage[];
    approvedApprovalRequest: ApprovedApprovalRequestMessage;
    shouldDisplayBackButton?: boolean;
}

export const ApprovedState = ({
    offer,
    approvalRequests,
    approvedApprovalRequest,
    shouldDisplayBackButton,
}: ApprovedStateProps) => {
    return (
        <ApprovalRequestBasicContent
            approvalRequests={approvalRequests}
            offer={offer}
            shouldDisplayBackButton={shouldDisplayBackButton}
        >
            <ApprovedStatusBar approvalRequest={approvedApprovalRequest} />
        </ApprovalRequestBasicContent>
    );
};
